export type VenueKind = 'bar' | 'restaurant' | 'other'

export type TabSource = 'manual' | 'scan'

export type Tab = {
  id: string
  createdAt: number
  /** Local calendar day the tab happened, YYYY-MM-DD */
  date: string
  venue: string
  kind: VenueKind
  billCents: number
  /** Voluntary tip base (before auto-grat line). Tip % applies here. */
  tipCents: number
  tipPercent: number
  /** Auto-grat or mandatory service charge already on the check (optional). */
  autoGratCents?: number
  /** Set when auto-grat was entered as a % of the bill (for history display). */
  autoGratPercent?: number
  source: TabSource
}

export const VENUE_KINDS: { id: VenueKind; label: string }[] = [
  { id: 'bar', label: 'Bar' },
  { id: 'restaurant', label: 'Restaurant' },
  { id: 'other', label: 'Other' },
]
